import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import { withFetch } from 'shared/hocs/withFetch';
import { InputText, InputPhoneNumber, Button, } from 'shared/components/UI';
import { isValidPhone } from 'shared/validations/validations';
import yourCarIcon from 'shared/assets/icons/yourCarIcon.svg';
import { ExchangeIcon } from 'shared/components/Icons';
import { sandEmail } from './service';
import s from './DealerServiceExchangeForm.css';

class DealerServiceExchangeForm extends React.Component {
  static propTypes = {
    onSent: PropTypes.func,
    dealerSlug: PropTypes.string.isRequired,
    service: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    advertInfo: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    onSent: () => {},
  };

  state = {
    phone: '',
    name: '',
    errorMessage: '',
    successMessage: '',
    disabled: true,
  };

  validateForm = () => {
    const { phone } = this.state;
    if (phone && !isValidPhone(phone.replace(/\s/g, ''))) {
      this.setState({ errorMessage: this.props.t('Некорректный номер телефона') });
      return false;
    }
    return !!phone;
  };

  handleInput = (field, value) => {
    this.setState({
      [field]: value,
      errorMessage: '',
      disabled: !this.state.phone || !this.state.name,
    });
  };

  handleSubmit = () => {
    if (!this.validateForm()) return;
    const { dealerSlug, advertInfo, service } = this.props;
    const { phone, name } = this.state;
    const dataToEmail = {
      slug: dealerSlug,
      phone,
      name,
      service,
      advertId: advertInfo.advertId,
    };

    this.setState({ disabled: true });
    const errMsg = 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';
    sandEmail(dataToEmail, this.props.fetch)
      .then(data => {
        this.setState({ disabled: false });
        if (data) this.props.onSent();
        else if (!data) this.setState({ errorMessage: errMsg });
      })
      .catch(() => {
        this.setState({
          disabled: false,
          errorMessage: errMsg,
        });
      });
  };

  render() {
    const { errorMessage, successMessage, name, phone, disabled } = this.state;
    const { t, advertInfo } = this.props;

    const carPicStyle = {
      backgroundImage: `url(${advertInfo.photos[0].image})`,
    };
    const currency = 'грн';
    const price = (advertInfo.prices || []).find(p => p.currency === currency);

    return (
      <div>
        <div className={s.carBlock}>
          <div className={s.carBlockLeft}>
            <div className={s.carBlockImage} style={carPicStyle} />
            <div>
              {advertInfo.title}
            </div>
            <div className={s.carBlockPrice}>
              {price.value} {currency}
            </div>
          </div>
          <div className={s.circleExchangeBlock}>
            <div className={s.circleExchange}>
              <ExchangeIcon />
            </div>
          </div>
          <div className={s.carBlockRight}>
            <div className={s.carBlockImage}>
              <img src={yourCarIcon} alt="Продать" width="90" height="90" />
            </div>
            <div>Ваш автомобль</div>
          </div>
        </div>
        <form className={s.requestForm}>
          <InputPhoneNumber
            name={'phone'}
            value={phone}
            changeHandler={(name, value) => this.handleInput(name, value)}
          />
          <InputText
            name={'name'}
            value={name}
            placeholder={name || t('Введите имя')}
            changeHandler={(name, value) => this.handleInput(name, value)}
          />
          {/* <div className={s.agreeCheckbox}>
            <CheckBox text="Я согласен, чтобы мне позвонили" name="agree" />
          </div> */}
          <Button
            type="button"
            text={t('Подтвердить номер')}
            disabled={disabled}
            onClick={e => {
              this.handleSubmit(e);
            }}
          />
        </form>
        {(errorMessage || successMessage) &&
          <span
            className={cx(
              { [s.errorMessage]: errorMessage },
              { [s.successMessage]: successMessage },
            )}
          >
            {t(errorMessage || successMessage)}
          </span>}
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(withFetch(DealerServiceExchangeForm)));



// WEBPACK FOOTER //
// ./src/shared/components/DealerServiceExchangeForm/DealerServiceExchangeForm.js